/**
 * Open a Dodo customer-portal session (block 32). Resolves to the portal URL;
 * navigating there is the caller's job.
 */
import { useMutation } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
export function useOpenBillingPortal() {
    return useMutation({
        mutationFn: async () => (await getNookClient().openBillingPortal()).portalUrl,
    });
}
//# sourceMappingURL=use-open-billing-portal.js.map